import { useMediaQuery } from '@mui/material'
import classNames from 'classnames'
import React, { Suspense, useContext, useEffect } from 'react'
import { lazyWithPreload } from 'react-lazy-with-preload'

import { staticAsset } from '@js/common/utils'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import QuestionHeading from '@f/applications/QuizApp/partials/QuestionHeading'
import QuizBottom from '@f/applications/QuizApp/partials/QuizBottom'
import QuizBottomCheckoutDesktop from '@f/applications/QuizApp/partials/QuizBottomCheckoutDesktop'
import QuizBottomCheckoutMobile from '@f/applications/QuizApp/partials/QuizBottomCheckoutMobile'
import { QuizStepTransition } from '@f/applications/QuizApp/partials/QuizStepTransition'
import CheckoutTransitionInMultiPoint from '@f/applications/QuizApp/questions/checkout/CheckoutTransitionMultiPoint'

import { QUIZ_CONFIG_CONVERSION_TYPES, QUIZ_STEP_TYPES } from './quizConstants'

const RenderCheckoutStep = lazyWithPreload(() =>
  import('@f/applications/QuizApp/partials/RenderCheckoutStep')
)

export const CheckoutRenderer = ({
  isNewMobileCheckoutDesign,
  currentStep,
  displayTransitionIn,
  setDisplayTransitionIn,
  displayCheckoutWithImage,
  onSuccess
}) => {
  const context = useContext(QuizContext)
  const isDesktopView = useMediaQuery('(min-width: 901px)')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    RenderCheckoutStep.preload()
  }, [])

  const isStandaloneFinanceQuiz =
    window?.quiz_config?.conversionType ===
    QUIZ_CONFIG_CONVERSION_TYPES.financeStandalone

  return (
    <>
      {isNewMobileCheckoutDesign && (
        <img
          src={
            currentStep.checkoutPreviewImageMobile ||
            staticAsset('/assets/checkout-background-mobile.png')
          }
          alt='Häuser'
        />
      )}
      {displayTransitionIn ? (
        <CheckoutTransitionInMultiPoint
          onTransitionEnd={() => setDisplayTransitionIn(false)}
          transitionInMultiPoint={context.data.transitionInMultiPoint}
        />
      ) : (
        <div
          className={classNames(!isStandaloneFinanceQuiz && 'f-c-ba-whi', {
            'QuizApp-checkout-rounded': isNewMobileCheckoutDesign,
            'f-fl-default f-d-flc': displayCheckoutWithImage
          })}>
          <QuestionHeading
            heading={currentStep.heading}
            wrapClassName='[ f-m-h-auto ] QuizApp-checkout-wrap is-page'
          />
          <div
            className={classNames(
              '[ f-pos-rel f-m-h-auto f-fl-expand ] QuizApp-wrap QuizApp-overflow',
              (isNewMobileCheckoutDesign || displayCheckoutWithImage) &&
                'QuizApp-reset-bottom-spacing'
            )}>
            <div className={'f-d-flr'}>
              <div className='QuizApp-step QuizApp-wrap is-active'>
                <QuizStepTransition currentStep={currentStep}>
                  <Suspense
                    fallback={<div className='QuizApp-step__skeleton' />}>
                    <RenderCheckoutStep
                      step={currentStep}
                      onSuccess={onSuccess}
                    />
                  </Suspense>
                </QuizStepTransition>
              </div>
            </div>
          </div>
          {(() => {
            if (
              context.data.exclusiveVendorNid ||
              isDesktopView ||
              isStandaloneFinanceQuiz ||
              (!isDesktopView &&
                currentStep.type === QUIZ_STEP_TYPES.checkoutValueMessage)
            ) {
              return null
            }
            if (displayCheckoutWithImage)
              return (
                <QuizBottomCheckoutDesktop
                  text={currentStep.checkoutValueMessage}
                />
              )
            if (isNewMobileCheckoutDesign)
              return (
                <QuizBottomCheckoutMobile
                  text={currentStep.checkoutValueMessage}
                />
              )
            return <QuizBottom />
          })()}
        </div>
      )}
    </>
  )
}
